import { Farm } from 'state/types'
import { ChainId } from '../sdk'
import { BIG_ZERO } from './bigNumber'

// search farms for a given token address and if found return the price of the token from the farm
export function getTokenPriceFromAddress(farms: Farm[], tokenAddress : string){
    const farmsWithMainToken = farms.find((farm) => farm.token.address[ChainId.MAINNET] === tokenAddress)
    if (farmsWithMainToken) {      
      return farmsWithMainToken.token.busdPrice
    }
    const farmsWithQuoteToken = farms.find((farm) => farm.quoteToken.address[ChainId.MAINNET] === tokenAddress)
    if (farmsWithQuoteToken) {
      return farmsWithQuoteToken.quoteToken.busdPrice
    }
    return BIG_ZERO.toString()
  }